import OnlinePaymentTransactionProcessingModelBase from '../_generated/modelBases/online-payment-transaction-processing-model-base';

export default class OnlinePaymentTransactionProcessingModel extends OnlinePaymentTransactionProcessingModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
